var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSessionCountdown
        ? _c("h1", [
            _vm._v(
              "Session Expires At: " +
                _vm._s(_vm.sessionExpiresAt) +
                " Countdown: " +
                _vm._s(_vm._f("minutes")(_vm.remainingTimeInSession))
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            show: _vm.showSessionExpiresWarningModal,
            "dialog-size": "md",
            name: "SessionExpiresWarning"
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.SessionTimeoutModal.sessionTimeoutModalTitle"
                    )
                  ) +
                  "\n\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.SessionTimeoutModal.sessionTimeoutModalMessage",
                    {
                      remainingTimeInSession:
                        _vm.remainingTimeInSessionAsMinutes
                    }
                  )
                )
              }
            })
          ],
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [_vm._v("Logout")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function($event) {
                    return _vm.remainLoggedIn()
                  }
                }
              },
              [_vm._v("Remain Logged In")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }